import { render } from "./UserShow.vue?vue&type=template&id=1b9c9347&scoped=true"
import script from "./UserShow.vue?vue&type=script&lang=js"
export * from "./UserShow.vue?vue&type=script&lang=js"

import "./UserShow.vue?vue&type=style&index=0&id=1b9c9347&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\supportgroup\\staff.supportgroup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9c9347"]])

export default __exports__